import { Component, inject, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-blog-teaser',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule],
  templateUrl: './blog-teaser.component.html',
  styleUrl: './blog-teaser.component.scss',
})
export class BlogTeaserComponent implements OnDestroy {
  translate = inject(TranslateService);
  posts: { title: string; slug: string; description: string }[] = [];
  
  private destroy$ = new Subject<void>();

  constructor() {
    this.updateTranslations();
    this.translate.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.updateTranslations());
  }

  private updateTranslations() {
    const translatedPosts = this.translate.instant('BLOG_TEASER.POSTS');
    this.posts = translatedPosts.map((post: any) => ({
      title: post.TITLE,
      slug: post.SLUG,
      description: post.DESC,
    }));
  }

  scrollToTop(event: Event): void {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
